(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[648],{

/***/ 58844:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inbox",
      function () {
        return __webpack_require__(91521);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 91521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "InboxPage": function() { return /* binding */ InboxPage; },
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _noahsaso_cosmodal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46938);
/* harmony import */ var _noahsaso_cosmodal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_noahsaso_cosmodal__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55351);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76699);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53476);
/* harmony import */ var _dao_dao_stateful__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63064);
/* harmony import */ var _dao_dao_stateless__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57572);
/* harmony import */ var _dao_dao_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62413);
// GNU AFFERO GENERAL PUBLIC LICENSE Version 3. Copyright (C) 2022 DAO DAO Contributors.
// See the "LICENSE" file in the root directory of this package for more copyright information.








var InnerInbox = function() {
    var connected = (0,_noahsaso_cosmodal__WEBPACK_IMPORTED_MODULE_1__.useWallet)().connected;
    var pinnedDaoDropdownInfos = (0,recoil__WEBPACK_IMPORTED_MODULE_3__/* .useRecoilValue */ .sJ)(_dao_dao_stateful__WEBPACK_IMPORTED_MODULE_4__/* .pinnedDaoDropdownInfosSelector */ .lb);
    var ref = (0,_dao_dao_stateless__WEBPACK_IMPORTED_MODULE_5__/* .useAppLayoutContext */ .bm4)(), _inbox = ref.inbox, loading = _inbox.loading, refetching = _inbox.refetching, refetch = _inbox.refetch, daosWithOpenProposals = _inbox.daosWithOpenProposals;
    var daosWithProposals = daosWithOpenProposals.map(function(param) {
        var coreAddress = param.coreAddress, proposalModules = param.proposalModules, openProposals = param.openProposals;
        var daoDropdownInfo = pinnedDaoDropdownInfos.find(function(dao) {
            return dao.coreAddress === coreAddress;
        });
        if (!daoDropdownInfo || !openProposals) {
            return undefined;
        }
        return {
            dao: daoDropdownInfo,
            proposals: openProposals.map(function(param) {
                var prefix = param.proposalModule.prefix, proposalNumber = param.proposalNumber;
                return {
                    chainId: _dao_dao_utils__WEBPACK_IMPORTED_MODULE_6__/* .CHAIN_ID */ .Kj,
                    coreAddress: coreAddress,
                    proposalId: "".concat(prefix).concat(proposalNumber),
                    proposalModules: proposalModules,
                    proposalViewUrl: "/dao/".concat(coreAddress, "/proposals/").concat(prefix).concat(proposalNumber)
                };
            })
        };
    }).filter(Boolean);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_dao_dao_stateless__WEBPACK_IMPORTED_MODULE_5__/* .Inbox */ .mnm, {
        LinkWrapper: _dao_dao_stateful__WEBPACK_IMPORTED_MODULE_4__/* .LinkWrapper */ .gM,
        ProposalLine: _dao_dao_stateful__WEBPACK_IMPORTED_MODULE_4__/* .ProposalLine */ .Ff,
        daosWithProposals: loading ? {
            loading: true
        } : {
            loading: false,
            data: daosWithProposals
        },
        onRefresh: refetch,
        refreshing: loading || refetching,
        rightSidebarContent: connected ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_dao_dao_stateful__WEBPACK_IMPORTED_MODULE_4__/* .ProfileHomeCard */ .wH, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_dao_dao_stateful__WEBPACK_IMPORTED_MODULE_4__/* .ProfileDisconnectedCard */ .$k, {})
    });
};
var __N_SSG = true;
var InboxPage = function() {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_2__/* .NextSeo */ .PB, {
                description: t("info.inboxDescription"),
                openGraph: {
                    url: _dao_dao_utils__WEBPACK_IMPORTED_MODULE_6__/* .SITE_URL */ ._O + "/inbox",
                    title: t("title.inbox"),
                    description: t("info.inboxDescription")
                },
                title: t("title.inbox")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_dao_dao_stateful__WEBPACK_IMPORTED_MODULE_4__/* .SuspenseLoader */ .yI, {
                fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_dao_dao_stateless__WEBPACK_IMPORTED_MODULE_5__/* .PageLoader */ .wY3, {}),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InnerInbox, {})
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (InboxPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(58844); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);